import { supabase } from '../lib/supabase';

const TABLE_NAME = 'client_contacts';

// Get all contacts for a client
export const getClientContacts = async (clientId) => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select('*')
    .eq('client_id', clientId)
    .order('is_main_contact', { ascending: false })
    .order('name', { ascending: true });

  if (error) throw error;
  return data || [];
};

// Get main contact for a client
export const getMainContact = async (clientId) => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select('*')
    .eq('client_id', clientId)
    .eq('is_main_contact', true)
    .single();

  if (error && error.code !== 'PGRST116') throw error; // PGRST116 is "not found"
  return data || null;
};

// Create a new contact
export const createContact = async (contactData) => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .insert([contactData])
    .select()
    .single();

  if (error) throw error;
  
  // If this contact is set as main, unset others
  if (contactData.is_main_contact) {
    await unsetOtherMainContacts(contactData.client_id, data.id);
  }
  
  return data;
};

// Update a contact
export const updateContact = async (contactId, updates) => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .update(updates)
    .eq('id', contactId)
    .select()
    .single();

  if (error) throw error;
  
  // If this contact is set as main, unset others
  if (updates.is_main_contact) {
    await unsetOtherMainContacts(data.client_id, contactId);
  }
  
  return data;
};

// Delete a contact
export const deleteContact = async (contactId) => {
  const { error } = await supabase
    .from(TABLE_NAME)
    .delete()
    .eq('id', contactId);

  if (error) throw error;
};

// Helper function to unset other main contacts
const unsetOtherMainContacts = async (clientId, excludeContactId) => {
  const { error } = await supabase
    .from(TABLE_NAME)
    .update({ is_main_contact: false })
    .eq('client_id', clientId)
    .eq('is_main_contact', true)
    .neq('id', excludeContactId);

  if (error) throw error;
};
